import React from 'react';
import { IonModal, IonButton, IonIcon } from '@ionic/react';
import { closeOutline, checkmarkCircle } from 'ionicons/icons';
import { useConfig } from '../hooks/useConfig';
import './UpgradePrompt.css';

/**
 * UpgradePrompt Component (FREE version only)
 * Displays upgrade to PRO prompt
 */
function UpgradePrompt({ isOpen, onClose }) {
  const { config } = useConfig();

  if (!config?.monetization?.showUpgradePrompt) {
    return null;
  }

  const handleUpgrade = () => {
    const upgradeUrl = config.monetization.upgradeUrl;
    if (upgradeUrl) {
      window.open(upgradeUrl, '_system');
    }
    onClose();
  };

  const upgradeFeatures = config.monetization.upgradeFeatures || [
    'Remove all ads',
    'Unlock exclusive content',
    'Priority support',
    'Offline downloads',
    'Custom themes'
  ];

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className="upgrade-modal">
      <div className="upgrade-prompt">
        <button className="close-btn" onClick={onClose}>
          <IonIcon icon={closeOutline} />
        </button>

        <div className="upgrade-header">
          <span className="crown-icon">👑</span>
          <h2>Upgrade to Pro</h2>
          <p>Get the ultimate learning experience!</p>
        </div>

        <div className="upgrade-features">
          {upgradeFeatures.map((feature, index) => (
            <div key={index} className="feature-item">
              <IonIcon icon={checkmarkCircle} className="check-icon" />
              <span>{feature}</span>
            </div>
          ))}
        </div>

        <div className="upgrade-price">
          <span className="price">{config.monetization.upgradePrice || '$4.99'}</span>
          <span className="price-label">One-time purchase</span>
        </div>

        <div className="upgrade-actions">
          <IonButton expand="block" onClick={handleUpgrade} className="upgrade-btn">
            Upgrade Now
          </IonButton>
          
          <IonButton fill="clear" onClick={onClose} className="later-btn">
            Maybe Later
          </IonButton>
        </div>

        <p className="guarantee-text">
          🔒 Secure payment • Lifetime access
        </p>
      </div>
    </IonModal>
  );
}

export default UpgradePrompt;